// extracted by mini-css-extract-plugin
export default {"root":"zXTmseZe","titleContainer":"OfB6pLHQ","right":"OWFzKRlm"};